import type {ConferenceUser} from "@inpriton/types/conferenceTypes";

// RISKS.md/P2.85: online too, since leaving never clears `joined` and the fresh join of someone
// with no tab left clears the admission anyway, so an Admit for someone who has gone admits nobody.
export const isWaiting = (u: ConferenceUser) => u.joined && !u.admitted && u.online
